<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
        :visible.sync="dialogVisibl"
        width="70%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="margin-left:50px">
<el-upload
          class="upload-demo"
          ref="upload"
          :limit="1" 
          :http-request="ImgUploadSectionFile"
          :with-credentials="true"
          :auto-upload="true"
          accept=".png,.jpg,.svg"
          action=""
          list-type="list"
          :file-list="fileList">
           <el-button slot="trigger" type="primary">选取图片</el-button>
         </el-upload>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibl = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "IconManagementDialog",
  data() {
    return {
        dialogVisibl:false,
        title:"",
        fileList: [],
        myForm:{},
        IconName:"",
        files:{},
    };
  },
  watch:{},
  methods: {
      handleRemove(file, fileList) {
        this.files = file
      },
      handlePreview(file) {
        this.files = file
      },
      onError(err,file,fileList){
        this.files = file
      },
      onSuccess(response, file, fileList){
        if(response.code  === 200){
          this.$message({
            message: response.msg,
            type: 'success'
          });
        }else{
          this.$message({
            message: response.msg,
            type: 'warning'
          });
        }
      },
      ImgUploadSectionFile(param){//图片上传
      // console.log(param)
     let formData = new FormData();//formdata格式
       formData.append('files', param.file);
       this.$http.post(this.$requestUrl.ICON_UPLPAD_FILE,formData).then(res => {
         if (res.code == 200){//成功
            this.$message({
            message: "上传成功",
            type: 'success'
          });
         }
       });
   },
   modification(){
     this.dialogVisibl = false
     this.$emit("Visibl",false)
   },
  //     ImgUploadSectionFile(param){
  // let fromData = new FormData();//formdata格式
  //               fromData.append('Img', param.files);
  //               // console.log(fromData)
  //                 this.$http.post(this.$requestUrl.ICON_UPLPAD_FILE,fromData).then((res) => {
  //                   console.log(res)
  //     }).catch(() => {
  //       this.$message.error(this.$errorMessage.SEVER_ERROR)
  //     })
  //               // request.post("url", formData).then(res => {
  //               //     if (res.code == 200){//成功
  //               //         console.log(res)
  //               //     }
  //               // });
  //     },
    // modification(){
    //      this.files.name = this.IconName
    //     this.$refs.upload.submit();
    //   // if(this.IconName != "" && this.IconName != null && this.IconName != undefined){
    //   //   this.file.name = this.IconName
    //   //   this.$refs.upload.submit();
    //   // }else{
    //   //     this.$message({
    //   //       message: "请填写Icon名称",
    //   //       type: 'warning'
    //   //     });
    //   // }
    // },
    handleClose(done) {
      this.dialogVisible = false
    },
  },
    mounted() {
    // this.houseId()
  }
}
</script>

<style scoped lang="scss">
// .commonDialogBody {
//     line-height: ;
// }
</style>